module.exports = __webpack_public_path__ + "img/13.cbdd4228.jpg";